import 'core-js/stable';
import 'regenerator-runtime/runtime';

// window.fetch polyfill
import 'whatwg-fetch';
